package team.platforma.chat_data.model

import team.platforma.chatdata.table.Draft

data class SendMessageData(
    val chatId: Long,
    val aiModelId: Long,
    val userID: Long,
    val textMessage: String,
    val status: String,
    val senderId: Long
)
